import { ComponentProps } from "react";
import {
  IInputContainerProps,
  InputContainer,
} from "../Inputs/InputContainer/inputContainer";

type TextAreaProps = ComponentProps<"textarea"> & IInputContainerProps;
export const TextArea = ({ label, required, ...rest }: TextAreaProps) => {
  return (
    <InputContainer label={label} required={required}>
      <textarea {...rest} required={required} style={{ height: "170px" }} />
    </InputContainer>
  );
};
